module.exports = __webpack_public_path__ + "static/media/hotel-4.1bdd83d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sponsorships/slider/hotel-4.jpg
// module id = 638
// module chunks = 6